import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TopProductsWidget = () => {
  const topProducts = [
    {
      id: 1,
      name: 'Wireless Bluetooth Headphones',
      category: 'Electronics',
      sales: 156,
      revenue: 23400,
      image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=100&h=100&fit=crop',
      trend: 'up',
      trendValue: '+12%'
    },
    {
      id: 2,
      name: 'Gaming Mechanical Keyboard',
      category: 'Gaming',
      sales: 134,
      revenue: 20100,
      image: 'https://images.pexels.com/photos/2115257/pexels-photo-2115257.jpeg?w=100&h=100&fit=crop',
      trend: 'up',
      trendValue: '+8%'
    },
    {
      id: 3,
      name: 'Smartphone Case Premium',
      category: 'Accessories',
      sales: 98,
      revenue: 2940,
      image: 'https://images.pixabay.com/photo/2016/12/09/11/33/smartphone-1894723_960_720.jpg?w=100&h=100&fit=crop',
      trend: 'down',
      trendValue: '-3%'
    },
    {
      id: 4,
      name: 'Wireless Mouse Pro',
      category: 'Electronics',
      sales: 87,
      revenue: 6960,
      image: 'https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=100&h=100&fit=crop',
      trend: 'up',
      trendValue: '+15%'
    },
    {
      id: 5,
      name: 'USB-C Hub Adapter',
      category: 'Accessories',
      sales: 76,
      revenue: 4560,
      image: 'https://images.pexels.com/photos/163100/circuit-circuit-board-resistor-computer-163100.jpeg?w=100&h=100&fit=crop',
      trend: 'up',
      trendValue: '+5%'
    }
  ];

  const getTrendIcon = (trend) => {
    return trend === 'up' ? 'TrendingUp' : 'TrendingDown';
  };

  const getTrendColor = (trend) => {
    return trend === 'up' ? 'text-success' : 'text-error';
  };

  return (
    <div className="bg-white rounded-lg border border-border shadow-elevation-1 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Top Products</h3>
        <Icon name="Award" size={20} className="text-primary" />
      </div>

      <div className="space-y-4">
        {topProducts.map((product, index) => (
          <div key={product.id} className="flex items-center space-x-4 p-3 rounded-md hover:bg-muted transition-micro">
            <div className="flex items-center justify-center w-8 h-8 bg-primary text-primary-foreground rounded-full text-sm font-bold">
              {index + 1}
            </div>
            
            <div className="w-12 h-12 rounded-md overflow-hidden bg-muted">
              <Image
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground truncate">{product.name}</h4>
              <p className="text-xs text-muted-foreground">{product.category}</p>
            </div>
            
            <div className="text-right">
              <div className="flex items-center space-x-2">
                <div>
                  <p className="text-sm font-medium text-foreground">${product.revenue.toLocaleString()}</p>
                  <p className="text-xs text-muted-foreground">{product.sales} sold</p>
                </div>
                <div className={`flex items-center space-x-1 ${getTrendColor(product.trend)}`}>
                  <Icon name={getTrendIcon(product.trend)} size={14} />
                  <span className="text-xs font-medium">{product.trendValue}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-border">
        <button className="text-sm text-primary hover:text-primary/80 font-medium transition-micro">
          View all products
        </button>
      </div>
    </div>
  );
};

export default TopProductsWidget;